import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';
import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input, Modal
} from 'reactstrap';
import Parametri from '../../parametri';

import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import FinestraDialogo from '../FinestraDialogo.js';
import AppartenentiAggiungiRimuovi from './AppartenentiGruppoAggiungiRimuovi.js';

const STATO_INDEFINITO = 0;
const STATO_INSERISCI = 1;
const STATO_MEMORIZZAZIONE = 2;//utilizzato per eseguire le operazioni di inserimento/modifica/eliminazione record
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_OPERAZIONE_FALLITA = 4;
const STATO_RICERCA_DATI = 5;//utilizzato nel caso modifica e cancella quando vado a ricercare i dati per popolare i campi della scheda
const STATO_RICERCA_DATI_CORRETTA = 6;//utilizzato a valle della ricerca dati record in caso di modifica o cancellazione di un record


function FormGridFormRow(props) {
    
    const [operazione,setOperazione] = useState('');
    const [variazioneCampi,setvariazioneCampi]=useState(0);

    const [flagAttivaModaleGruppoNonCancellabile, setFlagAttivaModaleGruppoNonCancellabile] = useState(0);
    const [flagAttivaModaleGruppoNonModificabile, setFlagAttivaModaleGruppoNonModificabile] = useState(0);
    const [flagAttivaModaleGruppoNonInseribile, setFlagAttivaModaleGruppoNonInseribile] = useState(0);
    const [flagAttivaModaleInserisciDescrizione, setFlagAttivaModaleInserisciDescrizione] = useState(0);

    const descrizione   = useRef();
    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [error,setError]=useState('');
    const [risultatoServer,setRisultatoServer]=useState('');

    //let descrizioneDefault = "";

    const [descrizioneDefault,setDescrizioneDefault]=useState('');

    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [loading,setLoading]= useState(false);

    const [numeroIscrittIAppartenenti, setNumeroIscrittiAppartenenti] = useState(0);
    const [modaleAppartenentiAggiungiRimuovi, setModaleAppartenentiAggiungiRimuovi] = React.useState(false);
    const [stringhePersone,setStringhePersone] = useState([]);
    const [persone, setPersone] = useState([]);
    const [azioneAppartenenti, setAzioneAppartenenti] = React.useState("");

    useEffect(() => {
        setStatoPagina(STATO_INSERISCI);
    },[]);

    useEffect(() => {
        if(props.ope==='inserisci') setOperazione("gruppiIns");
        if(props.ope==='modifica') setOperazione("gruppiMod");
        if(props.ope==='cancella') setOperazione("gruppiCanc");

        if(props.ope==="modifica" || props.ope==="cancella"){
            //devo eseguire una fetch per popolare i campi della scheda con i dati presi da db per il record in esame:
            // parametri per inviare i dati al server:
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({op:"gruppiRecuperaDati",
                    id:props.id,
                    emak: props.emak,
                    sessionId:props.sessionId
                })
            };
            setStatoPagina(STATO_RICERCA_DATI);

            fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valoreDiRitorno) => {
                    if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                        alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                    }
                    if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                    if(valoreDiRitorno.risultatoOperazione===1){
                        setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                        setDescrizioneDefault(valoreDiRitorno.gruppo[0].DESCRIZIONE);
                        setPersone(valoreDiRitorno.persone);
                        impostaVariabiliDopoScaricamento(valoreDiRitorno.persone);
                        //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                        }
                    },
                (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            ); 
        }else{
            setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
        } 
    },[props.ope]);

    function impostaVariabiliDopoScaricamento(persone) {
        var strPers=[];
        var nIscritti = 0;
        //console.log("per"+persone.length)
        for (let i=0; i<persone.length; i++) {
            strPers[i] = persone[i].COGNOME;
            if (persone[i].COGNOME!="" && persone[i].NOME!="") strPers[i]+=" ";
            strPers[i] += persone[i].NOME;
            if (persone[i].NUMERO_TESSERA !== "") strPers[i] += " ("+persone[i].NUMERO_TESSERA+")";
            if (persone[i].APPARTENENTE=='1') {
                 nIscritti++; 
            }
        }
        setStringhePersone(strPers);
        setNumeroIscrittiAppartenenti(nIscritti);
        //console.log("vale"+nIscritti)
        setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
    }
    function scaricaPersoneNonAppartenenti() {
        setStatoPagina(STATO_MEMORIZZAZIONE);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "gruppiPersoneNonAppartenenti", idGruppo: props.id, emak: props.emak, sessionId:props.sessionId })
        }
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINE.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { alert("Operazione fallita: sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); return; }                    

                    setPersone(valore_di_ritorno.persone);
                    impostaVariabiliDopoScaricamento(valore_di_ritorno.persone);
                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                },
                (error) => {
                    console.log("ERRORE DA BACKEND NON GESTITO (catch)");
                    props.callback(props.PAGINE.login);
                    return;
                }
            );
    }  
    function inviaVariazioneAppartenenti(elencoID, azione) {
        setStatoPagina(STATO_MEMORIZZAZIONE);
        var op = "appartenentiGruppiAggiungi";
        if (azione == "rimuoviAppartenenti") op = "appartenentiGruppiRimuovi";

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: op, idGruppo: props.id, elenco: elencoID, emak: props.emak, sessionId:props.sessionId })
        };

        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.setPagina(props.PAGINE.tornaLogin); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { alert("Operazione fallita: Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); return; }
                    // scarica nuovamente tutte le persone in modo da aggiornare gli appartenenti, eventualmente recependo anche variazioni fatte da altri nel frattempo           
                    scaricaPersoneNonAppartenenti();
                },
                (error) => {
                    console.log("ERRORE DA BACKEND NON GESTITO (catch)");
                    props.callback(props.PAGINE.login);
                    return;
                }
            );
    }
    function callbackAppartenentiAggiungiRimuovi(elenco,azione) {        
        setModaleAppartenentiAggiungiRimuovi(false);       
        inviaVariazioneAppartenenti(elenco,azione);
    }


    function tornaElenco() {
        props.callbackTermineModifica();
    }
    function tornaScheda() {
        setFlagAttivaModaleGruppoNonCancellabile(0);
        setFlagAttivaModaleGruppoNonModificabile(0);
        setFlagAttivaModaleGruppoNonInseribile(0);
        setFlagAttivaModaleInserisciDescrizione(0);
    }

    function handleCambiamentoMod(event) {
        //event.preventDefault();
        setvariazioneCampi(1);
    }

    function fetchOperazioneServer(permessoCanc=0,bypassaControlli=0) {
        let controlli=0;
        //cancello comunque;
        if(props.ope!=='cancella' && bypassaControlli===0){
            if(descrizione.current.value=== ''){
                controlli = 1;
                setFlagAttivaModaleInserisciDescrizione(1);
            }
        }

        if(controlli===0){ 
            //invio l'azione da fare sul server (aggiungi/togli) e l'elemento in esame al server che mi ritornerà l'elenco aggiornato
            //console.log("eccolo"+permessoCanc);
            if(props.ope==='modifica' && variazioneCampi===0){
                //in relatà non e stata fatta alcuna variazione nei campi originali per cui torno ad elenco:
                tornaElenco();
            }else{
                setLoading(true);
                // parametri per inviare i dati al server:
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: props.ope!=='cancella' ? 
                    JSON.stringify({op:operazione,
                        descrizione:descrizione.current.value,
                        idElemento:props.id,
                        emak: props.emak,
                        sessionId:props.sessionId
                        })
                        : 
                        JSON.stringify({op:operazione,
                        idElemento:props.id,
                        permessoCanc:permessoCanc,
                        emak: props.emak,
                        sessionId:props.sessionId})
                };
            
                // qui faccio la chiamata alla pagina sul server, quindi ne leggo la risposta che io trasformo in oggetto json 
                // con .json() ottenendo "valore_di_ritorno": in questo oggetto json ho "risultato_ritorno" che metto nella 
                // variabile di stato "risultato_server"
                //setStatoPagina(STATO_MEMORIZZAZIONE);

                fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                    .then(risposta => risposta.json())
                    .then(
                    (valoreDiRitorno) => {
                        setLoading(false);
                        if(valoreDiRitorno.risultatoOperazione===1) tornaElenco();
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            if(valoreDiRitorno.mess !== undefined){
                                if(valoreDiRitorno.mess.indexOf("Raggruppamento non cancellabile: presente in persone") !== -1){
                                    setFlagAttivaModaleGruppoNonCancellabile(1);
                                } 
                                if(valoreDiRitorno.mess.indexOf("Raggruppamento non modificabile: presente altro record uguale") !== -1){
                                    setFlagAttivaModaleGruppoNonModificabile(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Raggruppamento non inseribile: presente altro record uguale") !== -1){
                                    setFlagAttivaModaleGruppoNonInseribile(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Descrizione non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciDescrizione(1);
                                }
                            }else{
                                //altrimenti vado in errore generico
                                setStatoPagina(STATO_OPERAZIONE_FALLITA);
                            }
                        }
                    },
                    (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                );
             }
        }
    }

    //JSON.stringify(risultatoServer)
    
    /*defaultValue={{ label: {descrizioneGruppoDefault}, value: {gruppoDefault} }}*/
        return (
            <Fragment>
                
                {/*eccola {props.sessionId}*/}
                
                {statoPagina === STATO_MEMORIZZAZIONE ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}
                {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1Gru {error.message} {JSON.stringify(risultatoServer)}</div> :""}
                {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}
                {statoPagina === STATO_RICERCA_DATI ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}

           

                {statoPagina === STATO_RICERCA_DATI_CORRETTA ?
                <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>

                    {flagAttivaModaleInserisciDescrizione===1 ?
                        <Modale 
                            titolo="Richiesta descrizione"
                            flagErrore={true}
                            contenuto={<div>Non è stata indicata la descrizione, che è necessaria</div>}
                            bottoni={[
                                {
                                    "etichetta":"OK",
                                    "tipo":"primary",
                                    callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                                }    
                            ]}
                        />
                    :""}

                    {flagAttivaModaleGruppoNonCancellabile===1 ?
                        <Modale 
                            titolo="Informativa raggruppamento non cancellabile"
                            flagErrore={true}
                            contenuto={<div>Il raggruppamento risulta associato ad uno o più iscritti. 
                                Procedendo con la cancellazione verranno eliminate anche tutte le associazioni del raggruppamento in esame con gli iscritti</div>}
                            bottoni={[
                                {
                                    "etichetta":"OK",
                                    "tipo":"primary",
                                    callback:() => {setDisabilitaBottoni(false);fetchOperazioneServer(1)}
                                },  
                                {
                                    "etichetta":"Annulla",
                                    "tipo":"primary",
                                    callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                                }   
                            ]}
                        />
                    :""}

                    {flagAttivaModaleGruppoNonModificabile===1 ?
                        <Modale 
                            titolo="Informativa raggruppamento non modificabile"
                            flagErrore={true}
                            contenuto={<div>La descrizione del raggruppamento non è modificabile in {descrizione.current.value} poichè nel database è già presente un raggruppamento con la stessa descrizione</div>}
                            bottoni={[
                                {
                                    "etichetta":"OK",
                                    "tipo":"primary",
                                    callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                                }    
                            ]}
                        />
                    :""}

                    {flagAttivaModaleGruppoNonInseribile===1 ?
                        <Modale 
                            titolo="Informativa raggruppamento non inseribile"
                            flagErrore={true}
                            contenuto={<div>Il raggruppamento {descrizione.current.value} non è inseribile in poichè nel database è già presente un raggruppamento con la stessa descrizione</div>}
                            bottoni={[
                                {
                                    "etichetta":"OK",
                                    "tipo":"primary",
                                    callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                                }    
                            ]}
                        />
                    :""}

                    <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                            
                                {modaleAppartenentiAggiungiRimuovi &&  
                                <AppartenentiAggiungiRimuovi 
                                    azioneAppartenenti={azioneAppartenenti}
                                    descrizioneGruppo={descrizioneDefault}
                                    setPagina={props.setPagina}
                                    PAGINE={props.PAGINE}
                                    mioId={props.identitaSelezionata.idpersona}
                                    idGruppo={props.id}
                                    persone={persone}
                                    stringhePersone={stringhePersone}
                                    callbackAppartenentiAggiungiRimuovi={callbackAppartenentiAggiungiRimuovi}
                                /> 
                            }
                      
                            {props.ope === "inserisci" ? <CardTitle>Inserimento Raggruppamento</CardTitle> :""}
                            {props.ope === "modifica" ? <CardTitle>Modifica Raggruppamento</CardTitle> :""}
                      
                            
                            <Clessidra loading={loading}/>

                            {props.ope === "cancella" ?
                                <FinestraDialogo 
                                    titolo="Conferma eliminazione"
                                    flagErrore={true}                                
                                    contenuto={<div>
                                        Confermi l'eliminazione del raggruppamento <b>{descrizioneDefault}</b> ?<br/>                                    
                                    </div>}
                                    bottoni={[
                                        {
                                            "etichetta":"Conferma",
                                            "tipo":"primary",
                                            callback:() => {setDisabilitaBottoni(true);fetchOperazioneServer()}
                                        },
                                        {
                                            "etichetta":"Annulla",
                                            "tipo":"primary",
                                            callback: () => {tornaElenco()}
                                        }
                                    ]}
                                />                        

                            :

                                <>
                                <Row form>  
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="descrizione">Descrizione Raggruppamento*</Label>
                                            {props.ope === "inserisci" || props.ope === "modifica" ?
                                                <Input  maxLength={200} type="text" name="descrizione" id="descrizione"
                                                innerRef={descrizione} 
                                                placeholder=""
                                                defaultValue={descrizioneDefault}
                                                onInput={(e)=>{handleCambiamentoMod(e);setDescrizioneDefault(descrizione.current.value);}}/> 
                                            :""}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <div className='schedaSottotitolo'>
                                Iscritti appartenenti al Raggruppamento {numeroIscrittIAppartenenti > 0 && ": " + numeroIscrittIAppartenenti}
                                </div>
                                


                                {numeroIscrittIAppartenenti > 0 ?
                            <Row form>
                            <Col md={12}>
                            <Table bordered className="mb-0">
                            <tbody>
                            {/*<tr>
                            <td className="titoloTabella">Iscritto</td>
                            </tr>*/}
                            
                            {persone.map((x,i) =>
                                x.APPARTENENTE==1 ?
                                <Fragment>
                                <tr>
                                <td>{stringhePersone[i]}</td>
                                </tr>
                                </Fragment>
                            : ""
                            )}
                            </tbody>
                            </Table>

                            </Col>
                            </Row>
                        :
                        
                            <Row form><Col md={12}>
                            {props.ope=="inserisci" ? 
                                    <Label>Potrai associare degli iscritti al raggruppamento dopo aver inserito il raggruppamento</Label>
                                :
                                    <Label>Non ci sono iscritti appartenenti a questo raggruppamento</Label>
                                }
                            </Col></Row>
                        }












                                </>

                            }
                               
                                 
                                </div>

                                <div className="schedaSpazioInferiore">
                                {props.ope === "inserisci" ? <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Inserisci</Button> :""}
                                {props.ope === "modifica" && variazioneCampi === 1? <Button disabled={disabilitaBottoni} color="warning" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Memorizza Modifiche</Button>:""}

                                <Button disabled={disabilitaBottoni} color="primary" className="mt-2" onClick={() => tornaElenco()} >
                                {(variazioneCampi === 1 && props.ope === "modifica")?  <Fragment> Annulla </Fragment>: <Fragment>Torna all'elenco</Fragment>}
                                </Button>

                                {props.ope === "modifica" && variazioneCampi === 0 &&
                        <>

                            <Button disabled={disabilitaBottoni} className="mt-2 bottoneMargineASinistra" color='primary' onClick={() => {setModaleAppartenentiAggiungiRimuovi(true); setAzioneAppartenenti("aggiungiAppartenenti")}}>Aggiungi Iscritti al Raggruppamento</Button>
                            <Button disabled={disabilitaBottoni} className="mt-2 bottoneMargineASinistra" color='primary' onClick={() => {setModaleAppartenentiAggiungiRimuovi(true); setAzioneAppartenenti("rimuoviAppartenenti")}}>Rimuovi Iscritti dal Raggruppamento</Button>

                        </>
                    }  
                                </div>
  
                </div>
                :""}
            </Fragment>
        );
}
export default FormGridFormRow;
